import { ViewFactory } from 'wdc-cube-react'
import IntegracaoMonitoramentoFormScope from '../integracao-monitoramento_form.scopes'
import IntegracaoMonitoramentoFormView from './integracao-monitoramento_form.view'

export function registerViews(rv = ViewFactory.register) {
    rv(IntegracaoMonitoramentoFormScope, IntegracaoMonitoramentoFormView)
}
